import { Fragment, useEffect, useState } from "react";
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row, } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { useDispatch, useSelector } from "react-redux";
import CommonModal from "../../Components/Modals/modal";
// import { getCategory, updateCategory, addCategory, deleteCategory, } from "../../store/categorySlice";
import Empty from "../../Components/Empty/Index";
import SweetAlert from "sweetalert2";
import { getsubscription, ModalToggle, isOpenModal, addsubscription, updatesubscription, } from "../../store/subscriptionSlice";

const SubscriptionTable = () => {
  const storeVar = useSelector((state) => state.subscription);
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: "",
    limit: 10,
    offset: 0,
    currentPage: 1,
    status: "ACTIVE",
    modalTitle: null,
    editState: false,
    subscriptionId: "",
    title: "",
    price: '',
    discountedPrice: '',
    duration: '',
    bestValue: true,
    desc: ''
  });

  useEffect(() => {
    dispatch(getsubscription(formVar.limit, formVar.offset, formVar.status, formVar.keyword)
    );
  }, []);

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true));
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      subscriptionId: data._id,
      modalTitle: "Edit Category",
      title: data.title,
      price: data.price,
      discountedPrice: data.discountedPrice,
      duration: data.duration,
      bestValue: data.bestValue,
      desc: data.desc,
    }));
  };
  const AddToggleModal = () => {
    dispatch(isOpenModal(true));
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: "Add Subscription",
      title: "",
      price: '',
      discountedPrice: '',
      duration: '',
      bestValue: true,
      desc: ''
    }));
  };

  const submitMenu = () => {
    if (titleValid() || descValid() || validityValid() || priceValid() || discountedPriceValid()) {
      setSubmit(true);
      return null;
    }
    setSubmit(false);
    if (formVar.editState) {
      dispatch(updatesubscription(formVar.subscriptionId, {
        title: formVar.title,
        price: formVar.price,
        discountedPrice: formVar.discountedPrice,
        duration: formVar.duration,
        bestValue: formVar.bestValue,
        desc: formVar.desc,
      }));
    } else {
      dispatch(addsubscription({
        title: formVar.title,
        price: formVar.price,
        discountedPrice: formVar.discountedPrice,
        duration: formVar.duration,
        bestValue: formVar.bestValue,
        desc: formVar.desc,
      }));
    }
  };
  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  };
  const descValid = () => {
    if (!formVar.desc) {
      return "Description is required";
    }
  };
  const validityValid = () => {
    if (!formVar.duration) {
      return "Validity is required";
    }
  };
  const priceValid = () => {
    if (!formVar.price) {
      return "Price is required";
    }
  };
  const discountedPriceValid = () => {
    if (!formVar.discountedPrice) {
      return "Price is required";
    }
  };

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        // dispatch(deleteCategory(data._id));
      }
    });
  };

  return (
    <Fragment>
      <Col sm="12">
        <Card>
          <CardHeader>
            <Row>
              <Col md="6"></Col>
              <Col md="4">
              </Col>
              <Col
                md="2"
                className="d-flex justify-content-end align-items-center"
              >
                <div className="text-end border-2 w-100">
                  <Btn
                    attrBtn={{
                      color: "info-gradien", className: "w-100", size: "sm", onClick: AddToggleModal,
                    }}
                  >
                    Add Subscription
                  </Btn>
                </div>
              </Col>
            </Row>
          </CardHeader>
          <div className="table-responsive">
            <Table hover={true} className="table-border-horizontal table-light">
              <thead>
                <tr>
                  <th scope="col">Sl.No</th>
                  <th scope="col">Name</th>
                  <th scope="col">Price</th>
                  <th scope="col">Discounted Price</th>
                  <th scope="col">Validity</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.subscriptionData?.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                    <td>{item.discountedPrice}</td>
                    <td>{item.duration}</td>
                    <td>
                      <div className="d-flex gap-2 align-items-center">
                        <div className="cursor-pointer bg-light-primary font-primary action-icon">
                          <i
                            className="fa fa-edit fa-lg"
                            onClick={(e) => EditToggleModal(item)}
                          ></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className="cursor-pointer bg-light-info font-danger action-icon">
                          <i
                            className="fa fa-trash fa-lg"
                            onClick={(e) => DeleteModel(item)}
                          ></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {storeVar.categoryData?.length <= 0 && <Empty />}
        </Card>
      </Col>
      <CommonModal
        isOpen={storeVar.isOpenModal}
        title={formVar.modalTitle}
        toggler={toggle}
      >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Title</Label>
            <Input className="form-control" type="text" placeholder="Enter Subscription Title"
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value, }))}
              value={formVar.title}
            />
            {submit && titleValid() ? (<span className="d-block font-danger">{titleValid()}</span>) : ("")}
            <Row>
              <Col>
                <Label className="col-form-label" for="recipient-name">Price</Label>
                <Input className="form-control" type="text" placeholder="Enter Price"
                  onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, price: e.target.value, }))}
                  value={formVar.price}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)}
                />
                {submit && priceValid() ? (<span className="d-block font-danger">{priceValid()}</span>) : ("")}
              </Col>
              <Col>
                <Label className="col-form-label" for="recipient-name"> Discounted Price</Label>
                <Input className="form-control" type="text" placeholder="Enter Discounted Price"
                  onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, discountedPrice: e.target.value, }))}
                  value={formVar.discountedPrice}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)}
                />
                {submit && priceValid() ? (<span className="d-block font-danger">{priceValid()}</span>) : ("")}
              </Col>
            </Row>
            <Row>
              <Col>
                <Label className="col-form-label" for="recipient-name">Validity</Label>
                <Input className="form-control" type="text" placeholder="Enter Validity"
                  onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, duration: e.target.value, }))}
                  value={formVar.duration}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)}
                />
                {submit && validityValid() ? (<span className="d-block font-danger">{validityValid()}</span>) : ("")}
              </Col>
              <Col>
                <Label className="col-form-label" for="recipient-name">Best Value</Label>
                <Input className="form-control" type="select"
                  onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, bestValue: e.target.value, }))}
                  value={formVar.bestValue}
                >
                  <option value="true">True</option>
                  <option value="false">False</option>
                </Input>
              </Col>
            </Row>
            <Label className="col-form-label" for="recipient-name">Description</Label>
            <textarea className='form-control' name='description' rows='4' placeholder='Enter Description' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, desc: e.target.value }))} value={formVar.desc} />
            {submit && descValid() ? (<span className="d-block font-danger">{descValid()}</span>) : ("")}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: "secondary", onClick: toggle }}>Close</Btn>
          <Btn attrBtn={{ color: "primary", onClick: submitMenu }}>
            Save Changes
          </Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default SubscriptionTable;